import React from 'react'
import LoadingSpinner from 'Components/LoadingSpinner'
import { ListLayout } from 'Components/Layouts'
import { useTranslation } from 'react-i18next'
import LargeScreenInvoicesList from './LargeScreen'
import SmallScreenInvoicesList from './SmallScreen'
import InvoicesListContext from './InvoicesListContext'
import { useInvoicesQuery } from 'hooks/useInvoicesQuery'
import { useDeleteInvoiceMutation } from 'hooks/useDeleteInvoiceMutation'

const InvoicesList = () => {
  const { t } = useTranslation()
  const { data: invoices, isLoading, isError } = useInvoicesQuery()
  const deleteMutation = useDeleteInvoiceMutation()

  async function deleteInvoice(invoice) {
    await deleteMutation.mutateAsync(invoice)
  }

  if (isLoading) return <LoadingSpinner />

  if (isError || invoices === undefined) {
    return <h2>{t('cannot_recover_list_of', { resource: t('invoices') })}</h2>
  }

  if (invoices.length === 0) return <h2>{t('not_invoices_found')}</h2>

  return (
    <InvoicesListContext.Provider value={{ invoices, deleteInvoice }}>
      <LargeScreenInvoicesList invoices={invoices} />
      <SmallScreenInvoicesList invoices={invoices} />
    </InvoicesListContext.Provider>
  )
}

export default () => (
  <ListLayout title="invoices">
    <InvoicesList />
  </ListLayout>
)
